// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"6057baa0","365":"43383f5a","787":"cdc148d5"}[chunkId] + ".chunk.js";
};